export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION = {
  GENERADO : 'generado',
  PENDIENTE : 'pendiente',
  APROBADA : 'aprobada',
  RECHAZADA : 'rechazada',
  OBSERVADO : 'observado',
};

export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS = {
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE]: 'Pendiente',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO]: 'Generado',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA]: 'Aprobada',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA]: 'Rechazada',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO]: 'Observado',
};

export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_COLORES = {
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE]: 'orange',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO]: 'primary',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.APROBADA]: 'success',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADA]: 'red',
  [ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.OBSERVADO]: 'teal',
};

export const ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LIST = [
  { value: null, text: 'Todos' },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.PENDIENTE],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.GENERADO],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.ENVIADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.ENVIADO],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.SINCRONIZADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[
      ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.SINCRONIZADO
    ],
  },
  {
    value: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADO,
    text: ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION_LABELS[ESTADOS_SOLICITUD_MODIFICACION_CALIFICACION.RECHAZADO],
  },
];
